import PriceMyRentalSearchModule from './index';

const PriceMyRentalSearchModuleBlock = {
  Component: PriceMyRentalSearchModule,
  BlockRenderer: () => <PriceMyRentalSearchModule />,
  metadata: {
    name: 'rentals/price-my-rental-search',
    title: 'Price My Rental Search',
    description: '',
    icon: 'businessperson',
    keywords: ['price', 'rent', 'rentals', 'search'],
    supports: {
      customClassName: false,
      html: false,
    },
    category: 'more',
    attributes: {},
  },
};

export default PriceMyRentalSearchModuleBlock;
